import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.liked;

const getLiked = createSelector(getData, liked => liked);

export default getLiked;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getLiked.js